import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { AppState } from '../../store';
import { selectAccountId } from '../../account/store/account.selectors';
import { Workspace } from '../workspaces.models';
import { QueryParams } from '../../models/http.models';

@Injectable({
  providedIn: 'root',
})
export class WorkspacesResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(workspace_id: number, params?: QueryParams): Observable<Workspace> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((store_account_id) =>
        this.http.get<Workspace>(`${this.apiRoot}/${store_account_id}/api/workspaces/${workspace_id}`, { params }),
      ),
    );
  }

  save(body: Partial<Workspace>, params?: QueryParams): Observable<Workspace> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.post<Workspace>(`${this.apiRoot}/${account_id}/api/workspaces`, body, { params }),
      ),
    );
  }

  update(workspace_id: number, body: Partial<Workspace>, params?: QueryParams): Observable<Workspace> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.put<Workspace>(`${this.apiRoot}/${account_id}/api/workspaces/${workspace_id}`, body, { params }),
      ),
    );
  }

  remove(workspace_id: number, params?: QueryParams): Observable<any> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.delete<Workspace>(`${this.apiRoot}/${account_id}/api/workspaces/${workspace_id}`, { params }),
      ),
    );
  }

  query(params?: QueryParams): Observable<Workspace[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) => this.http.get<Workspace[]>(`${this.apiRoot}/${account_id}/api/workspaces`, { params })),
    );
  }

  search(params?: QueryParams): Observable<Workspace[]> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Workspace[]>(`${this.apiRoot}/${account_id}/api/workspaces/search`, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Workspace', downgradeInjectable(WorkspacesResource));
